import React from 'react'
import css from './WelcomeOferta.module.css'

const WelcomeOferta = () => {
	return (
		<section className={css.welcomeSection}>
			<div className={css.welcomeContainer}>
				<p className={css.welcomeText}>OFERTA</p>
			</div>
		</section>
	)
}

export default WelcomeOferta
